module.exports = __webpack_public_path__ + "static/media/cookieMarkerLegacyPinSelected.ffbb9102.svg";